import { render } from "./AdminChat.vue?vue&type=template&id=7402529e&scoped=true"
import script from "./AdminChat.vue?vue&type=script&lang=js"
export * from "./AdminChat.vue?vue&type=script&lang=js"

import "./AdminChat.vue?vue&type=style&index=0&id=7402529e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7402529e"]])

export default __exports__